<template>
  <AuthPage :page="page">
    <div class="card mb-4">
      <TextInput
        v-model="email"
        autofocus
        required
        type="email"
        :label="fields.email.label"
        :disabled="submittingForm"
        autocomplete="email"
        :placeholder="fields.email.placeholder"
        :prompt="fields.email.prompt"
        :status="emailValidationStatus"
        :status-message="emailValidationMessage"
        @enter="resetPassword"
      />
    </div>

    <button
      type="button"
      class="btn btn-primary btn-large w-full"
      :disabled="submittingForm"
      :loading="submittingForm"
      @click="resetPassword"
    >
      {{ page.button }}

      <ArrowRight class="btn-icon-right" />
    </button>

    <p class="text-center mt-4">
      <n-link
        to="/login"
        class="mx-auto text-sm text-gray-500 hover:text-blue-600 focus:text-cool-gray-700 active:text-cool-gray-700 transition ease-in-out duration-150"
        v-html="page.prompt"
      ></n-link>
    </p>
  </AuthPage>
</template>

<script>
import ArrowRight from '@/assets/svg/icons/arrow-right.svg?inline'
import { email_validator } from '@/lib/constants/validators'
import AuthPage from '@/components/Account/AuthPage'
import TextInput from '@/components/form/TextInput'
import { getPages, meta } from '@/mixins/content'
import toasts from '@/content/data/error-toasts'
import authForm from '@/mixins/auth-form'
import { RESET_EMAIL_KEY } from '~/lib/constants/persistence'
import { useLocalStorage } from '@/lib/helpers/storage'

export default {
  components: { ArrowRight, TextInput, AuthPage },

  mixins: [meta, authForm, getPages(['auth-pages/reset'])],

  data: () => ({
    submittingForm: false,
    reset_success: false,
    email: '',
  }),

  validations: { email: email_validator },

  computed: {
    emailValidationMessage() {
      return this.reset_success
        ? toasts.reset_success
        : this.fields.email.message
    },

    emailValidationStatus() {
      if (this.$v.email.$error) {
        return 'error'
      } else if (this.reset_success) {
        return 'success'
      } else {
        return null
      }
    },
  },

  mounted() {
    // Handle pre-setting the users email, in case we redirect from somewhere
    if (this.$route.query.email) {
      this.email = this.$route.query.email.toLowerCase()
    }
  },

  methods: {
    async resetPassword() {
      if (this.$invalidInput()) return

      this.submittingForm = true

      try {
        const auth = await this.$getAuthInstance()
        await auth.forgotPassword(this.email.toLowerCase())

        this.submittingForm = false
        this.reset_success = true

        useLocalStorage().setItem(RESET_EMAIL_KEY, this.email.toLowerCase())
      } catch (err) {
        this.$store.commit('error/incrementPasswordResetAttempts')

        this.submittingForm = false

        this.$toast.error(err.message)
      }
    },
  },
}
</script>
